import script from "./ViewAllActions.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAllActions.vue?vue&type=script&setup=true&lang=js"

import "./ViewAllActions.vue?vue&type=style&index=0&id=1d7ca179&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d7ca179"]])

export default __exports__